export const WARM_UP = 'warmUp';
export const STATION_1 = 'station1';
export const STATION_2 = 'station2';
export const STATION_3 = 'station3';
export const STATION_4 = 'station4';
